/* eslint-disable */
import $store from '@/store'
export function findPostHelper(state, postID) {
	let post = null;
	if(state.singlePost) {
		if(state.singlePost.id == postID) {
			post = state.singlePost;
		}
	}
	else if($store.getters['groups/groupPosts'].length) {
		post = $store.getters['groups/groupPosts'].find(post => post.id === postID);
	}
	else if($store.getters['wall/savedForLater'].data.length) {
		let item = $store.getters['wall/savedForLater'].data.find(item => item.post.id === postID);
		if(item) {
			post = item.post
		}
	}
	else if($store.getters['wall/problems'].length) {
		post = $store.getters['wall/problems'].find(post => post.id === postID);
	}
	else if($store.getters['wall/polls'].length) {
		post = $store.getters['wall/polls'].find(post => post.id === postID);
	}
	else if($store.getters['wall/userPosts'].length) {
		post = $store.getters['wall/userPosts'].find(post => post.id === postID);
	}
	else if($store.getters['groups/groupPosts'].length) {
		post = $store.getters['groups/groupPosts'].find(post => post.id === postID);
	}
	else {
		post = (state.posts.data).find(post => post.id === postID )
	}
	console.log("FOUND POST", post)
	return post;
}

export function findPostIndex(state, postID) {
	let index = -1;
	let where = null;
	if($store.getters['wall/savedForLater'].length) {
		index = $store.getters['wall/savedForLater'].findIndex(post => post.id == postID);
		where = 'groups';
	}
	return {
		index: index,
		where: where
	}
}

export function findCommentHelper(state, post, id) {
	return (post.comments).find(comment => comment.id === id )
}

export function findChatRoomHelper(state, id) {
	let r = null;
	if($store.getters['chat/rooms'].length) {
		r = $store.getters['chat/rooms'].find(x => x.id == id);
	}
	return r;
}

export function findChatRoomMessageHelper(state, room_id, message_id) {
	let message = null;
	if($store.getters['chat/rooms'].length) {
		let room = $store.getters['chat/rooms'].find(x => x.id == room_id);
		if(room?.messages?.data) {
			message = room.messages.data.find(x => x.id == message_id);
		}
	}
	return message;
}

export function findChatRoomMessageReactionHelper(state, room_id, message_id, reaction_id) {
	let reaction = null;
	if($store.getters['chat/rooms'].length) {
		let room = $store.getters['chat/rooms'].find(x => x.id == room_id);
		if(room?.messages?.data) {
			let message = room.messages.data.find(x => x.id == message_id);
			if(message && message.reactions && message.reactions.length) {
				reaction = message.reactions.find(x => x.id == reaction_id);
			}
		}
	}
	return reaction;
}
/* eslint-enable */
